import React, { useState, useEffect } from "react";
import { number, string } from "prop-types";

import NumberedStoryHeadline from "../NumberedStoryHeadline";
import CollectionNameTabs from "../CollectionNameTabs";

import { getCollectionBySlug } from "../../helper/api";

import "./serial-stories-tab.m.css";

const SerialStoriesTab = ({ collectionNames }) => {
  if (!collectionNames) return null;

  const maxNumberOfCollection = 3;
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [collections, setCollections] = useState([]);
  const onTabClick = (selectedTabIndex) => setSelectedIndex(selectedTabIndex);

  const collectionSlugs = collectionNames
    .split(",")
    .slice(0, maxNumberOfCollection)
    .map((item) => {
      const numberShow = /(\(f\))/i.test(item);
      const collName = String(item)
        .toLowerCase()
        .replace(/(\([a-z]\))/i, "")
        .trim();
      return {
        numberShow: !numberShow,
        name: collName,
      };
    });

  async function fetchCollections() {
    const storyFields = "headline,subheadline,slug,url,alternative,story-template,metadata";
    setCollections(
      await Promise.all(
        collectionSlugs.map(({ name }) => {
          return getCollectionBySlug(name, storyFields, 5);
        })
      )
    );
  }

  useEffect(() => {
    fetchCollections();
  }, []);

  if (!collections || !collections.length) {
    return null;
  }

  const collectionsNames = collections.map((item) => item.name);

  return (
    collections && (
      <div styleName="base" className="serial-stories-tabs">
        <CollectionNameTabs collectionList={collectionsNames} selectedIndex={selectedIndex} onTabClick={onTabClick} />
        {collections[selectedIndex] && collections[selectedIndex].items && (
          <NumberedStoryHeadline
            storyList={collections[selectedIndex].items}
            numberShow={collectionSlugs[selectedIndex].numberShow}
            className="numbered-story-headline card-with-image-zoom"
          />
        )}
      </div>
    )
  );
};

SerialStoriesTab.propTypes = {
  collectionNames: string,
  numberOfCollection: number,
};

export default SerialStoriesTab;
